export default "__VITE_ASSET__BYH4oHop__"